import React from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
    ReferenceField,
    TopToolbar,
    EditButton,
    useRecordContext,
    Identifier, RaRecord
} from 'react-admin';
import {
    Box,
    Grid
} from '@mui/material';

const ShowActions = () => {
    return (
        <TopToolbar>
            <EditButton />
        </TopToolbar>
    );
}

const ShowUrlTitle = () => {
    const record: RaRecord = useRecordContext();
    if (!record) return null;
    return <span>{ "Url - " + record.id }</span>
}

export const AdminUrlShow = () => {
    return(
        <Show actions={ <ShowActions /> } title={ <ShowUrlTitle /> }>
            <Grid container spacing={ 2 }>
                <Grid size={ 6 }>
                    <SimpleShowLayout>
                        <TextField source="id" />
                        <TextField source="path" />
                        <ReferenceField
                            label="Website"
                            source="website"
                            reference="websites"
                            link="show">
                            <TextField source="baseUrl" />
                        </ReferenceField>
                    </SimpleShowLayout>
                </Grid>
            </Grid>
        </Show>
    );
}